import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import { getViewStateFromUrl, setObjectInUrl } from "../../../helpers/urlHelpers";

export const withNavigationHistory = ComponentToWrap => {
  class NavigationHistoryComponent extends PureComponent {
    static propTypes = {
      routerParams: PropTypes.object,
      transition: PropTypes.object
    };

    static defaultProps = {
      routerParams: {},
      transition: {}
    };

    componentDidMount() {
      const componentToWrapSetState = this.componentRef.setState.bind(this.componentRef);
      this.componentRef.setState = state => {
        this.setState(state);
        componentToWrapSetState(state);
      };

      const urlState = getViewStateFromUrl(this.props.routerParams);
      if (urlState) {
        this.componentRef.setState({ ...urlState });
      }
    }

    componentDidUpdate(_prevProps, prevState) {
      if (prevState !== this.state) {
        setObjectInUrl(this.state, this.props.transition);
      }
    }

    componentRef;

    handleSetComponentRef = ref => {
      this.componentRef = ref;
    };

    render() {
      return <ComponentToWrap ref={this.handleSetComponentRef} {...this.props} />;
    }
  }

  const mapStateToProps = state => {
    return {
      routerParams: state.app.routerParams
    };
  };

  return connect(mapStateToProps)(NavigationHistoryComponent);
};



// WEBPACK FOOTER //
// ./src/components/Common/Navigation/withNavigationHistory.js